var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTripSchedulingBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 18H17.5V15.5H18.5V17H19.5V18ZM22 8.5H21.9978V14.5007C21.7143 14.1238 21.3789 13.7882 21.0022 13.5045V8.5H2.9978V18.5022H13.101C13.1717 18.8485 13.2793 19.1814 13.4177 19.4978H2.0022V8.5H2V7.5H2.0022V3.5022H7V2H8V3.5022H16V2H17V3.5022H21.9978V7.5H22V8.5ZM21.0022 7.5V4.4978H17V5.5H16V4.4978H8V5.5H7V4.4978H2.9978V7.5H21.0022ZM22 17.5C22 15.2944 20.2056 13.5 18 13.5C15.7944 13.5 14 15.2944 14 17.5C14 19.7056 15.7944 21.5 18 21.5C20.2056 21.5 22 19.7056 22 17.5ZM21 17.5C21 19.1542 19.6542 20.5 18 20.5C16.3458 20.5 15 19.1542 15 17.5C15 15.8458 16.3458 14.5 18 14.5C19.6542 14.5 21 15.8458 21 17.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripSchedulingBlack);
export default __webpack_public_path__ + "static/media/trip-scheduling-black.a421fe4c7070e456fe17e1c2d88214bc.svg";
export { ForwardRef as ReactComponent };